import { render, staticRenderFns } from "./ItemElementFavorite.vue?vue&type=template&id=57942880&scoped=true"
import script from "./ItemElementFavorite.vue?vue&type=script&lang=ts"
export * from "./ItemElementFavorite.vue?vue&type=script&lang=ts"
import style0 from "./ItemElementFavorite.vue?vue&type=style&index=0&id=57942880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57942880",
  null
  
)

export default component.exports